import localizeAjvEn from 'ajv-i18n/localize/en';

/**
 * Invokes the validation function on the configuration and throws an Error 
 * if any missconfiguration was found.
 * 
 * @param {string} identifier the identifier of the instance being validated. 
 * Might by component's id, the element the widget is created on, etc.
 * @param {function} validationFn The AJV generated validation function that determines if the config 
 * is valid or not.
 * @param {object} config The configuration to be checked.
 * @return {Promise} gets resolved if the configuration is valid, rejected otherwise.
 * @throws {Error} if the configuration is rejected
 * @memberof core.helpers
 */
function assertValidConfig(identifier, validationLoader, config) {
  if (!assertValidConfig.doValidation) {
    validationLoader.progress = Promise.resolve(true);
    return validationLoader.progress;
  }

  let p = new Promise(function(resolve, reject) {
    validationLoader(function(validationFn) {
      validationFn(config);
      if (validationFn.errors) {
        localizeAjvEn(validationFn.errors);
        validationLoader.errors = validationFn.errors;
        reject(validationFn.errors);
      } else {
        resolve(true);
      }
    });
  }).catch(function(errors) {
    // We throw the error here to prevent the validationLoader callback to fail, related to the 
    // way we are loading validations.
    let errorsStr = errors.map((error) => {
      let extraInfo = '';
      if (error.params.additionalProperty) {
        extraInfo = `(${error.params.additionalProperty})`;
      }
      return ` * ${error.dataPath} ${error.message} ${extraInfo}`;
    }).join('\n');
    throw new Error(`Configuration error(s) for ${identifier}:\n${errorsStr}`);
  });

  validationLoader.progress = p;

  return validationLoader.progress;
}

export default assertValidConfig;



// WEBPACK FOOTER //
// ./lmm-widget/src/helpers/assertValidConfig.js